//@flow
import React, { Component } from "react";
import "./pricing.scss";
import CurrencyFormat from "react-currency-format";

type Props = {
  isPostCodeAvailable: boolean,
  onShowPostcodeClicked: () => void,
  price: ?number
};

class Price extends Component<Props> {
  showPrice(price: ?number) {
    return (
      <div className="wishlist-tile__product-price">
        <CurrencyFormat
          value={price}
          displayType={"text"}
          prefix={"$"}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
        />
        <span className="wishlist-tile__price-suffx"> (inc. gst)</span>
      </div>
    );
  }

  showEnterYourPostCodeLink() {
    return (
      <div className="wishlist-tile__postcode-link-wrapper">
        <a className="postcode-link" onClick={this.props.onShowPostcodeClicked}>
          Enter your postcode to see pricing
        </a>
      </div>
    );
  }

  render() {
    const isPostCodeAvailable = this.props.isPostCodeAvailable;
    const price: ?number = this.props.price;
    let pricingContainer;
    if (isPostCodeAvailable) {
      pricingContainer = this.showPrice(price);
    } else {
      pricingContainer = this.showEnterYourPostCodeLink();
    }

    return (
      <div className="wishlist-tile__product-pricing">{pricingContainer}</div>
    );
  }
}

export default Price;
